import React from 'react';
import {imagePropsTitle, imageProps, limitTime} from './data';
import * as S from './style';
import {BreadCrumb, CardSection} from '../../../Components/Template';
import {Container, Image} from '../../../Components/Atom';
import {ContentTitle} from '../../../Components/Organism';
import {expiredIMG} from '../../../config/images';
import styled from 'styled-components';
import {viewSize, colorPalette} from '../../../config';

export const ExpiredImg = styled.img`
	width: 50%;
	@media screen and (max-width: ${viewSize.mobile}) {
		width: 100%;
	}
`;
export const ExpiredText = styled.div`
	color: ${colorPalette.primary};
	font-family: 'Gmarket';
	font-size: 35px;
	font-weight: 600;
	text-align: center;
	@media screen and (max-width: ${viewSize.mobile}) {
		font-size: 20px;
	}
`;

const Course = () => {
	return (
		<Container>
			<BreadCrumb depths={['HOME', '대회코스']} />
			<S.Container>
				<S.ImgWrapper>
					{/* <ContentTitle {...imageProps.title0} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course0} />
					</S.CardWrapper> */}
					<ContentTitle {...imageProps.title} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course} />
					</S.CardWrapper>
					<div style={{marginTop: '50px'}}></div>
					<ContentTitle {...imageProps.title2} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course2} />
					</S.CardWrapper>
					<div style={{marginTop: '50px'}}></div>
					<ContentTitle {...imageProps.title3} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course3} />
					</S.CardWrapper>
					<div style={{marginTop: '50px'}}></div>
					<ContentTitle {...imageProps.title4} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course4} />
					</S.CardWrapper>
				</S.ImgWrapper>
				<S.CardWrapper>
					<CardSection {...limitTime} />
				</S.CardWrapper>
				{/* <div
					style={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<ExpiredImg src={expiredIMG} />
					<ExpiredText>업데이트 예정</ExpiredText>
				</div> */}
			</S.Container>
		</Container>
	);
};

export default Course;
